<template>
  <vue-perfect-scrollbar
    class="scroll-area relative"
    :class="{ 'pointer-events-none': isLoading }"
  >
    <vx-card style="height: 99vh">
      <vs-popup
        title="New Role"
        :active.sync="popupActive12"
        fullscreen
        v-if="popupActive12"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="Name"
          v-model="roleMetadataRefined.name"
          class="w-full"
        />
        <br />
        <span><b>Pages</b></span>
        <vs-row v-for="(item, i) in access.pages" :key="'pages' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.pages"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>

        <br />
        <span><b>Reports</b></span>
        <vs-row v-for="(item, i) in access.reports" :key="'reports' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.reports"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>

        <br />
        <span><b>Actions</b></span>
        <vs-row v-for="(item, i) in access.actions" :key="'actions' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.actions"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>
        <br />

        Assign Users
        <ejs-multiselect
          id="multiselect3"
          :dataSource="userData"
          v-model="roleMetadataRefined.users"
          :fields="fields3"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Users"
        ></ejs-multiselect>
        <br />
        <br />
        <vs-button @click="addRole2">Proceed</vs-button>
      </vs-popup>
      <vs-popup
        title="Edit Role"
        :active.sync="popupActive13"
        fullscreen
        v-if="popupActive13"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="Name"
          v-model="roleMetadataRefined.name"
          class="w-full"
        />
        <br />
        <span><b>Pages</b></span>
        <vs-row v-for="(item, i) in access.pages" :key="'pages2' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.pages"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>

        <br />
        <span><b>Reports</b></span>
        <vs-row v-for="(item, i) in access.reports" :key="'reports2' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.reports"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>

        <br />
        <span><b>Actions</b></span>
        <vs-row v-for="(item, i) in access.actions" :key="'actions2' + i">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
            >{{ item.label }}
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
            <vs-switch
              color="success"
              v-model="roleMetadataRefined.actions"
              :vs-value="item.value"
            />
          </vs-col>
        </vs-row>
        <br />

        Assign Users
        <ejs-multiselect
          id="multiselect3"
          :dataSource="userData"
          v-model="roleMetadataRefined.users"
          :fields="fields3"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Users"
        ></ejs-multiselect>
        <br />
        <br />
        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
            <vs-button @click="updateRole">Update</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
            <vs-button color="danger" @click="deleteRole"
              >Delete Role</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'Update Group - ' + selectedGroup.name"
        :active.sync="popupActive3"
        v-if="popupActive3"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="Name"
          v-model="selectedGroup.name"
          class="w-full"
        />
        <div :key="'15' + refreshKey">
          <br />
          Assign Units
          <ejs-multiselect
            v-if="popupActive3"
            id="multiselect"
            :fields="fields1"
            v-model="selectedGroup.units"
            :dataSource="unitData"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Units"
          ></ejs-multiselect
          ><br />
          Assign Users
          <ejs-multiselect
            id="multiselect3"
            :dataSource="userData"
            v-model="selectedGroup.users"
            :fields="fields3"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Users"
          ></ejs-multiselect
          ><br />
          <br />
          Assign POI
          <ejs-multiselect
            id="multiselect4"
            :dataSource="poiData"
            v-model="selectedGroup.poi"
            :fields="fields4"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select POI"
          ></ejs-multiselect
          ><br />
          <br />
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="updateGroup"
            >Update</vs-button
          >

          <br />
          <vs-button
            v-if="selectedGroup.id != 1"
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="deleteGroup"
            >Delete</vs-button
          >
          <br />
        </div>
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'New Group'"
        :active.sync="popupActive4"
        v-if="popupActive4"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="Name"
          v-model="selectedGroup.name"
          class="w-full"
        />
        <br />
        Assign Units
        <ejs-multiselect
          v-if="popupActive4"
          id="multiselect"
          :fields="fields1"
          v-model="selectedGroup.units"
          :dataSource="unitData"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Units"
        ></ejs-multiselect
        ><br />
        Assign Users
        <ejs-multiselect
          id="multiselect3"
          :dataSource="userData"
          v-model="selectedGroup.users"
          :fields="fields3"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Users"
        ></ejs-multiselect
        ><br />
        <br />
        Assign POI
        <ejs-multiselect
          id="multiselect4"
          :dataSource="poiData"
          v-model="selectedGroup.poi"
          :fields="fields4"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select POI"
        ></ejs-multiselect
        ><br />
        <br />

        <br /><br />
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-feather"
          size="small"
          @click="addGroup2"
          >Add New Group</vs-button
        >
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'Add User'"
        :active.sync="popupActive9"
        v-if="popupActive9"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          icon-pack="feather"
          label-placeholder="Name"
          v-model="selectedUser.name"
          class="w-full"
        />
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="username"
              label-placeholder="Username"
              v-model="selectedUser.username"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/2 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="password"
              label-placeholder="Password"
              v-model="selectedUser.password"
              class="w-full"
            />
          </div>
        </div>

        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="email"
              label-placeholder="Email"
              v-model="selectedUser.email"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="help_call"
              label-placeholder="Support Phone"
              v-model="userMetadataRefined.help_call"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="help_whatsapp"
              label-placeholder="Support Whatsapp"
              v-model="userMetadataRefined.help_whatsapp"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Company"
              label-placeholder="Company"
              v-model="userMetadataRefined.company"
              class="w-full"
            />
          </div>
        </div>

        <br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <label>Select Created User</label>
            <v-select
              :options="userData"
              placeholder="Select Created User"
              v-model="userMetadataRefined.createdBy"
              :clearable="false"
              value="username"
              label="username"
            >
              <template slot="option" slot-scope="option">
                {{ option.username }} / {{ option.name }}
              </template>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4 w-half" :key="'14' + refreshKey">
            <label>Select Role</label>
            <v-select
              :options="roleData"
              placeholder="Select Role"
              v-model="userMetadataRefined.role"
              :clearable="false"
              value="id"
              label="name"
            >
              <template slot="option" slot-scope="option">
                #{{ option.id }} / {{ option.name }}
              </template>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vue-dropzone
              ref="vehicleImages"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-success="smallLogoUpload"
              v-on:vdropzone-removed-file="smallLogoRemove"
            ></vue-dropzone>
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Logo URL (Small)"
              label-placeholder="Logo URL (Small)"
              v-model="userMetadataRefined.logo_small_url"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vue-dropzone
              ref="vehicleImages"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-success="bigLogoUpload"
              v-on:vdropzone-removed-file="bigLogoRemove"
            ></vue-dropzone>
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Logo URL (Big)"
              label-placeholder="Logo URL (Big)"
              v-model="userMetadataRefined.logo_big_url"
              class="w-full"
            />
          </div>
          <!--

   <div class="vx-col md:w-1/4 w-half">
          <label>Immo Access</label>
          <vs-switch v-model="userMetadataRefined.immo">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label>StreetView Access</label>
          <vs-switch v-model="userMetadataRefined.streetview">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
        --></div>

        <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"

        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
        <br /><br />

        <div class="vx-row">
          <!--
    <div class="vx-col md:w-1/4 w-half">
          <label>Fleet Maintenance Access</label>
          <vs-switch v-model="userMetadataRefined.fms">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>


        -->

          <div class="vx-col md:w-1/4 w-half">
            <label>User Status</label>
            <v-select
              placeholder="Status"
              :clearable="false"
              :options="[
                'ACTIVE',
                'INACTIVE - PAYMENT RELATED',
                'INACTIVE - DISMANTLED',
                'INACTIVE - SUSPICIOUS USAGE',
              ]"
              class="mb-4 md:mb-0"
              v-model="selectedUser.status"
            />
          </div>
        </div>

        <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"

        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            Assign Units
            <ejs-multiselect
              v-if="popupActive9"
              id="multiselect"
              :fields="fields1"
              v-model="selectedUser.units"
              :dataSource="unitData"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Units"
            ></ejs-multiselect>
          </div>
          <div class="vx-col md:w-1/2 w-half">
            Assign to Groups
            <ejs-multiselect
              id="multiselect2"
              :dataSource="groupData"
              :fields="fields2"
              v-model="selectedUser.groups"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Groups"
            ></ejs-multiselect
            ><br />
          </div>
        </div>
        <br />
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-feather"
          size="small"
          @click="addUser2"
          >Add User</vs-button
        >
        <br />
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'Update User - ' + selectedUser.name"
        :active.sync="popupActive5"
        v-if="popupActive5"
      >
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="Name"
          v-model="selectedUser.name"
          class="w-full"
        />
        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="username"
              label-placeholder="Username"
              v-model="selectedUser.username"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/2 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="password"
              label-placeholder="Password"
              v-model="selectedUser.password"
              class="w-full"
            />
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="email"
              label-placeholder="Email"
              v-model="selectedUser.email"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="help_call"
              label-placeholder="Support Phone"
              v-model="userMetadataRefined.help_call"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="help_whatsapp"
              label-placeholder="Support Whatsapp"
              v-model="userMetadataRefined.help_whatsapp"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Company"
              label-placeholder="Company"
              v-model="userMetadataRefined.company"
              class="w-full"
            />
          </div>
        </div>

        <br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <label>Select Created User</label>
            <v-select
              :options="userData"
              placeholder="Select Created User"
              v-model="userMetadataRefined.createdBy"
              :clearable="false"
              value="username"
              label="username"
            >
              <template slot="option" slot-scope="option">
                {{ option.username }} / {{ option.name }}
              </template>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4 w-half" :key="'13' + refreshKey">
            Select Role
            <ejs-multiselect
              id="multiselectxx"
              :fields="fields6"
              v-model="userMetadataRefined.role"
              :dataSource="roleData"
              popupHeight="400px"
              maximumSelectionLength="1"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="false"
              placeholder="Select Role"
            ></ejs-multiselect>
          </div>

          <div class="vx-col md:w-1/4 w-half">
            <vue-dropzone
              ref="vehicleImages"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-success="smallLogoUpload"
              v-on:vdropzone-removed-file="smallLogoRemove"
            ></vue-dropzone>
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Logo URL (Small)"
              label-placeholder="Logo URL (Small)"
              v-model="userMetadataRefined.logo_small_url"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vue-dropzone
              ref="vehicleImages"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-success="bigLogoUpload"
              v-on:vdropzone-removed-file="bigLogoRemove"
            ></vue-dropzone>
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="Logo URL (Big)"
              label-placeholder="Logo URL (Big)"
              v-model="userMetadataRefined.logo_big_url"
              class="w-full"
            />
          </div>
          <!--
   <div class="vx-col md:w-1/4 w-half">
          <label>Immo Access</label>
          <vs-switch v-model="userMetadataRefined.immo">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label>StreetView Access</label>
          <vs-switch v-model="userMetadataRefined.streetview">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>

        --></div>

        <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"

        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
        <br /><br />

        <div class="vx-row">
          <!--
 <div class="vx-col md:w-1/4 w-half">
          <label>Fleet Maintenance Access</label>
          <vs-switch v-model="userMetadataRefined.fms">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>

        -->

          <div class="vx-col md:w-1/4 w-half">
            <label>User Status</label>
            <v-select
              :clearable="false"
              placeholder="Status"
              :options="[
                'ACTIVE',
                'INACTIVE - PAYMENT RELATED',
                'INACTIVE - DISMANTLED',
                'INACTIVE - SUSPICIOUS USAGE',
              ]"
              class="mb-4 md:mb-0"
              v-model="selectedUser.status"
            />
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half" :key="'12' + refreshKey">
            Assign Units
            <ejs-multiselect
              v-if="popupActive5"
              id="multiselect"
              :fields="fields1"
              v-model="selectedUser.units"
              :dataSource="unitData"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Units"
            ></ejs-multiselect>
          </div>
          <div class="vx-col md:w-1/2 w-half" :key="'11' + refreshKey">
            Assign to Groups
            <ejs-multiselect
              id="multiselect2"
              :dataSource="groupData"
              :fields="fields2"
              v-model="selectedUser.groups"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Groups"
            ></ejs-multiselect
            ><br />
          </div>
        </div>
        <br /><br />

        <span>Telegram Accounts</span>
        <vs-table
          stripe
          :data="userMetadataRefined.telegram"
          style="z-index: 1"
        >
          <template slot="thead">
            <vs-th width="5%">No.</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Chat Id</vs-th>
            <vs-th>Actions</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <span>
                  <b>{{ indextr + 1 }}.</b></span
                >
              </vs-td>
              <vs-td>
                <span>
                  <b>{{ tr.name }}.</b></span
                >
              </vs-td>
              <vs-td>
                <span>
                  <b>{{ tr.chatId }}.</b></span
                >
              </vs-td>
              <vs-td>
                <vs-button size="small" @click="removeTelegram(indextr)"
                  >Remove</vs-button
                >
                &nbsp;
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            <vs-button color="success" type="filled" @click="updateUser"
              >Update</vs-button
            >
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <vs-button color="warning" type="filled" @click="deleteUserSessions"
              >Force Logout</vs-button
            >
          </div>
          <div class="vx-col md:w-1/3 w-half" :key="'10' + refreshKey">
            <vs-button color="danger" type="filled" @click="deleteUser"
              >Delete User</vs-button
            >
          </div>
        </div>
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'Add Unit'"
        :active.sync="popupActive2"
        v-if="popupActive2"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="name"
              label-placeholder="Name"
              v-model="selectedUnit.name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:3'"
              data-vv-validate-on="blur"
              name="unitId"
              label-placeholder="Unit Id"
              v-model="selectedUnit.unitId"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:3'"
              data-vv-validate-on="blur"
              name="cellular"
              label-placeholder="Cellular/SIM"
              v-model="unitMetadataRefined.cellular"
              class="w-full"
            />
          </div>
        </div>
        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/5 w-half">
            Brand<v-select
              placeholder="Brand"
              :options="['JOINTECH', 'STARCOM', 'TELTONIKA', 'ASR', 'DASHCAM']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.brand"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Model<v-select
              placeholder="Model"
              :options="[
                'MC402',
                'SMARTWATCH',
                'HELIOS',
                'LOKIES',
                'KYLOS',
                'GP4000A',
                'GP4000',
                'GP6000',
                'GP6000F',
                'FMC125',
                'FMB920',
                'FMC920',
                'FMC130',
                'FMC650',
              ]"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.model"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Type<v-select
              placeholder="Type"
              :options="[
                'CAR',
                'BUS',
                'LORRY/TRUCK',
                '4WD/PICKUP TRUCK',
                'MACHINERY',
                'MOTORCYCLE',
                'SUV',
                'Hatchback',
                'Crossover',
                'Convertible',
                'Sedan',
                'Sports Car',
                'Van',
                '1 tonne',
                '3 / 5 tonne',
                '10 Tonne (Cargo Truck)',
                '10 Tonne Tipper / Crane - 1',
                '20 Tonne Tipper / Crane - 1',
                'Ready Mix',
                'Prime Movers - 1',
                'Prime Movers - 2',
                'Backhoe Loaders',
                'Excavators',
                'Loader',
                'Bulldozers',
                'Skid Steel Loaders',
                'Shovels',
                'Motor Graders',
                'Motor Scrapers',
                'Dump Truck',
                'Dragline',
                'Trenchers',
                'Forklift',
              ]"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.type"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Installation Date
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="installation_date"
              type="date"
              v-model="unitMetadataRefined.installDate"
              class="w-half"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/5 w-half">
            Speed (Units)<v-select
              placeholder="Speed Metric"
              :options="['kph', 'knots', 'mph']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.speedMetric"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Mileage (Units)<v-select
              placeholder="Mileage Metric"
              :options="['km', 'miles']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.mileageMetric"
            />
          </div>
        </div>
        <!--   Status<v-select placeholder="Status" :options="['ACTIVE','INACTIVE','DISMANTLED']" class="mb-4 md:mb-0" :clearable="false"  v-model="selectedUnit.status"/>  -->

        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">
            <label>Fuel Tank 1 Status</label>
            <vs-switch v-model="unitMetadataRefined.f1Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.f1Status == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fuel"
              label-placeholder="Fuel 1 Capacity"
              v-model="unitMetadataRefined.fuel"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Fuel Tank 2 Status</label>
            <vs-switch v-model="unitMetadataRefined.f2Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.f2Status == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fuel"
              label-placeholder="Fuel 2 Capacity"
              v-model="unitMetadataRefined.fuel2"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 1 Status</label>
            <vs-switch v-model="unitMetadataRefined.i1Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i1Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i1Name"
              label-placeholder="Input 1 Name"
              v-model="unitMetadataRefined.i1_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 2 Status</label>
            <vs-switch v-model="unitMetadataRefined.i2Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i2Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i2Name"
              label-placeholder="Input 2 Name"
              v-model="unitMetadataRefined.i2_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 3 Status</label>
            <vs-switch v-model="unitMetadataRefined.i3Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i3Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i3Name"
              label-placeholder="Input 3 Name"
              v-model="unitMetadataRefined.i3_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Output 1 Status</label>
            <vs-switch v-model="unitMetadataRefined.o1Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.o1Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o1Name"
              label-placeholder="Output 1 Name"
              v-model="unitMetadataRefined.o1_name"
              class="w-full"
            />
            <!-- <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o1Seconds"
              label-placeholder="Output 1 "
              v-model="unitMetadataRefined.i1_seconds"
              class="w-full"
            /> -->
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Output 2 Status</label>
            <vs-switch v-model="unitMetadataRefined.o2Status">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.o2Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o2Name"
              label-placeholder="Output 2 Name"
              v-model="unitMetadataRefined.o2_name"
              class="w-full"
            />
            <!-- <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o1Seconds"
              label-placeholder="Output 1 "
              v-model="unitMetadataRefined.i1_seconds"
              class="w-full"
            /> -->
          </div>
        </div>

        <br />

        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">
            <label>Ignition Work Hours</label>
            <vs-switch v-model="unitMetadataRefined.enableWorkHoursStatus">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.enableWorkHoursStatus == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="ignitionworkhours"
              label-placeholder="Total Ignition Work Hours"
              v-model="unitMetadataRefined.totalWorkHours"
              class="w-full"
            />
          </div>
        </div>

        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            Assign to Users
            <ejs-multiselect
              id="multiselect3"
              :dataSource="userData"
              v-model="selectedUnit.users"
              :fields="fields3"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Users"
            ></ejs-multiselect>
          </div>
          <div class="vx-col md:w-1/2 w-half">
            Assign to Groups
            <ejs-multiselect
              id="multiselect2"
              :dataSource="groupData"
              :fields="fields2"
              v-model="selectedUnit.groups"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Groups"
            ></ejs-multiselect>
          </div>
        </div>

        <br />
        <vs-textarea
          label="Remarks"
          height="100px"
          v-model="unitMetadataRefined.remarks"
        />

        <br />

        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-feather"
          size="small"
          @click="addUnit"
          >Add New Asset</vs-button
        >

        <br />
      </vs-popup>
      <vs-popup
        fullscreen
        :title="'Edit Unit - ' + selectedUnit.name"
        :active.sync="popupActive"
        v-if="popupActive"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:5'"
              data-vv-validate-on="blur"
              name="name"
              label-placeholder="Name"
              v-model="selectedUnit.name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:3'"
              data-vv-validate-on="blur"
              name="unitId"
              label-placeholder="Unit Id"
              v-model="selectedUnit.unitId"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 w-half">
            <vs-input
              v-validate="'required|min:3'"
              data-vv-validate-on="blur"
              name="cellular"
              label-placeholder="Cellular/SIM"
              v-model="unitMetadataRefined.cellular"
              class="w-full"
            />
          </div>
        </div>
        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/5 w-half">
            Brand<v-select
              placeholder="Brand"
              :options="['JOINTECH', 'STARCOM', 'TELTONIKA', 'ASR', 'DASHCAM']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.brand"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Model<v-select
              placeholder="Model"
              :options="[
                'MC402',
                'SMARTWATCH',
                'HELIOS',
                'LOKIES',
                'KYLOS',
                'GP4000A',
                'GP4000',
                'GP6000',
                'GP6000F',
                'FMC125',
                'FMB920',
                'FMC920',
                'FMC130',
                'FMC650',
              ]"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.model"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Type<v-select
              placeholder="Type"
              :options="[
                'CAR',
                'BUS',
                'LORRY/TRUCK',
                '4WD/PICKUP TRUCK',
                'MACHINERY',
                'MOTORCYCLE',
                'SUV',
                'Hatchback',
                'Crossover',
                'Convertible',
                'Sedan',
                'Sports Car',
                'Van',
                '1 tonne',
                '3 / 5 tonne',
                '10 Tonne (Cargo Truck)',
                '10 Tonne Tipper / Crane - 1',
                '20 Tonne Tipper / Crane - 1',
                'Ready Mix',
                'Prime Movers - 1',
                'Prime Movers - 2',
                'Backhoe Loaders',
                'Excavators',
                'Loader',
                'Bulldozers',
                'Skid Steel Loaders',
                'Shovels',
                'Motor Graders',
                'Motor Scrapers',
                'Dump Truck',
                'Dragline',
                'Trenchers',
                'Forklift',
              ]"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.type"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Installation Date<vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="installation_date"
              type="date"
              v-model="unitMetadataRefined.installDate"
              class="w-half"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/5 w-half">
            Speed (Units)<v-select
              placeholder="Speed Metric"
              :options="['kph', 'knots', 'mph']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.speedMetric"
            />
          </div>
          <div class="vx-col md:w-1/5 w-half">
            Mileage (Units)<v-select
              placeholder="Mileage Metric"
              :options="['km', 'miles']"
              class="mb-4 md:mb-0"
              :clearable="false"
              v-model="unitMetadataRefined.mileageMetric"
            />
          </div>
        </div>
        <br />

        <!--
 Status<v-select placeholder="Status" :options="['ACTIVE','INACTIVE','DISMANTLED']" class="mb-4 md:mb-0" :clearable="false"  v-model="selectedUnit.status"/>

        -->

        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">
            <label>Fuel Tank 1 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.f1Status"
              @click="check(1)"
              :key="'9' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.f1Status == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fuel"
              label-placeholder="Fuel 1 Capacity"
              v-model="unitMetadataRefined.fuel"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Fuel Tank 2 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.f2Status"
              @click="check(2)"
              :key="'8' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.f2Status == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fuel"
              label-placeholder="Fuel 2 Capacity"
              v-model="unitMetadataRefined.fuel2"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 1 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.i1Status"
              @click="check(3)"
              :key="'7' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i1Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i1Name"
              label-placeholder="Input 1 Name"
              v-model="unitMetadataRefined.i1_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 2 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.i2Status"
              @click="check(6)"
              :key="'6' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i2Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i2Name"
              label-placeholder="Input 2 Name"
              v-model="unitMetadataRefined.i2_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Input 3 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.i3Status"
              @click="check(8)"
              :key="'6' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.i3Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="i3Name"
              label-placeholder="Input 3 Name"
              v-model="unitMetadataRefined.i3_name"
              class="w-full"
            />
          </div>

          <div class="vx-col md:w-1/6 w-half">
            <label>Output 1 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.o1Status"
              @click="check(7)"
              :key="'7' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.o1Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o2Name"
              label-placeholder="Output 1 Name"
              v-model="unitMetadataRefined.o1_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Output 2 Status</label>
            <vs-switch
              v-model="unitMetadataRefined.o2Status"
              @click="check(9)"
              :key="'7' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div
            class="vx-col md:w-1/6 w-half"
            v-if="unitMetadataRefined.o2Status == true"
          >
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="o2Name"
              label-placeholder="Output 2 Name"
              v-model="unitMetadataRefined.o2_name"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Temperature Status</label>
            <vs-switch
              v-model="unitMetadataRefined.tempStatus"
              @click="check(4)"
              :key="'6' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.tempStatus == true"
              name="temp"
              label-placeholder="Sensors"
              v-model="unitMetadataRefined.temp"
              class="w-full"
            />
            <vs-input
              v-if="unitMetadataRefined.tempStatus == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fuel"
              label-placeholder="Preferred Temp Line in Chart"
              v-model="unitMetadataRefined.tempPreferred"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <label>Humidity Status</label>
            <vs-switch
              v-model="unitMetadataRefined.humidityStatus"
              @click="check(10)"
              :key="'10' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.humidityStatus == true"
              name="humidity"
              label-placeholder="Sensors"
              v-model="unitMetadataRefined.humidity"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            Icon Type
            <v-select
              :options="iconList"
              placeholder="Type"
              v-model="unitMetadataRefined.iconType"
              :clearable="false"
              label="label"
              value="value"
            >
              <template slot="option" slot-scope="option">
                <div class="row-iconBox">
                  <span>{{ option.label }}</span>
                  <img
                    :src="
                      require(
                        `../experimental/map-view/icons/${option.label}.png`,
                      )
                    "
                    class="h-full border-grey-light border-solid border-1 rounded"
                    style="object-fit: contain; aspect-ratio: 1"
                    width="50"
                    height="50"
                  />
                </div>
              </template>
              <template #selected-option="{ label, value }">
                <div class="row-iconBox">
                  <span>{{ value }}</span>
                  <img
                    :src="
                      require(`../experimental/map-view/icons/${label}.png`)
                    "
                    class="h-full border-grey-light border-solid border-1 rounded"
                    style="object-fit: contain; aspect-ratio: 1"
                    width="50"
                    height="50"
                  />
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">
            <label>Ignition Work Hours</label>
            <vs-switch
              @click="check(5)"
              v-model="unitMetadataRefined.enableWorkHoursStatus"
              :key="'5' + refreshKey"
            >
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
            <vs-input
              v-if="unitMetadataRefined.enableWorkHoursStatus == true"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="ignitionworkhours"
              label-placeholder="Total Ignition Work Hours"
              v-model="unitMetadataRefined.totalWorkHours"
              class="w-full"
            />
          </div>
        </div>
        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            Assign to Users
            <ejs-multiselect
              id="multiselect3"
              :dataSource="userData"
              v-model="selectedUnit.users"
              :fields="fields3"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Users"
            ></ejs-multiselect>
          </div>
          <div class="vx-col md:w-1/2 w-half">
            Assign to Groups
            <ejs-multiselect
              id="multiselect2"
              :dataSource="groupData"
              :fields="fields2"
              v-model="selectedUnit.groups"
              popupHeight="400px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select Groups"
            ></ejs-multiselect>
          </div>
        </div>
        <br />
        <vs-textarea
          label="Remarks"
          height="100px"
          v-model="unitMetadataRefined.remarks"
        />

        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-half">
            <vs-button color="success" type="filled" @click="updateUnit"
              >Update</vs-button
            >
          </div>
          <div class="vx-col md:w-1/2 w-half">
            <vs-button color="danger" type="filled" @click="deleteUnit"
              >Delete</vs-button
            >
          </div>
        </div>
      </vs-popup>

      <!-- <vs-progress
        indeterminate
        color="primary"
        class="absolute top-0 left-0"
        v-if="isLoading"
      ></vs-progress> -->
      <vs-tabs>
        <vs-tab label="Units" icon="local_shipping" @click="showTab(1)">
          <vs-row vs-w="12">
            <vs-col vs-align="center" vs-w="4">
              <vs-button size="small" @click="addAsset"
                >Add New Asset</vs-button
              >
            </vs-col>
            <vs-col vs-align="center" vs-w="4">
              <v-select
                :options="groupData"
                placeholder="Filter Group"
                v-model="filteredGroup"
                value="name"
                label="name"
              >
                <template slot="option" slot-scope="option">
                  {{ option.name }} [{{ option.unitsCount }} units]
                </template>
              </v-select>
            </vs-col>
          </vs-row>
          <ejs-grid
            :key="'4' + refreshKey"
            :dataSource="unitData2"
            :allowTextWrap="true"
            :enableStickyHeader="true"
            height="70vh"
            gridLines="Both"
            :filterSettings="filterOptions"
            :allowPaging="true"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :searchSettings="searchOptions"
            :toolbar="toolbarOptions"
            ref="adminUnitsGrid"
            id="adminUnitsGrid"
            :pageSettings="pageSettings"
            :showColumnChooser="true"
            :allowSorting="true"
            :allowMultiSorting="true"
            :allowFiltering="true"
          >
            <e-columns>
              <e-column
                field="name"
                headerText="Asset Name"
                textAlign="Left"
              ></e-column>
              <e-column
                field="unitId"
                headerText="Unit Id"
                textAlign="Left"
              ></e-column>
              <e-column
                field="model"
                headerText="Model"
                textAlign="Left"
              ></e-column>
              <e-column
                field="cellular"
                headerText="Cellular"
                textAlign="Left"
              ></e-column>
              <e-column
                field="fuel"
                headerText="Fuel"
                textAlign="Left"
              ></e-column>
              <e-column
                field="lastUpdated"
                headerText="Last Updated"
                textAlign="Left"
              ></e-column>
              <e-column
                field="installDate"
                headerText="Install Date"
                textAlign="Left"
              ></e-column>
              <e-column
                field="remarks"
                headerText="Remarks"
                textAlign="Left"
              ></e-column>
              <e-column
                textAlign="Left"
                :template="cTemplate"
                width="80"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </vs-tab>

        <vs-tab label="Groups" icon="group" @click="showTab(2)">
          <vs-button size="small" @click="addGroup">Add New Group</vs-button
          ><br />
          <ejs-grid
            :key="'3' + refreshKey"
            v-if="show == 2"
            :dataSource="groupData"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick2"
            :allowTextWrap="true"
            :enableStickyHeader="true"
            height="70vh"
            gridLines="Both"
            :filterSettings="filterOptions"
            :allowPaging="true"
            :searchSettings="searchOptions3"
            :toolbar="toolbarOptions"
            ref="adminGroupsGrid"
            id="adminGroupsGrid"
            :pageSettings="pageSettings"
            :showColumnChooser="true"
            :allowSorting="true"
            :allowMultiSorting="true"
            :allowFiltering="true"
          >
            <e-columns>
              <e-column
                field="name"
                headerText="Name"
                textAlign="Left"
              ></e-column>
              <e-column
                field="unitsCount"
                headerText="Units"
                textAlign="Left"
              ></e-column>
              <!--    <e-column field='usersCount' headerText='Users'  textAlign='Left'></e-column>-->
              <e-column
                field="poiCount"
                headerText="POI"
                textAlign="Left"
              ></e-column>
              <e-column
                headerText="Manage"
                textAlign="Left"
                :template="cTemplate3"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </vs-tab>
        <vs-tab label="Users" icon="person" @click="showTab(3)">
          <vs-button size="small" @click="addUser">Add New User</vs-button
          ><br />
          <ejs-grid
            v-if="show == 3"
            :key="'2' + refreshKey"
            :dataSource="userData"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick3"
            :allowTextWrap="true"
            :enableStickyHeader="true"
            height="70vh"
            gridLines="Both"
            :filterSettings="filterOptions"
            :allowPaging="true"
            :searchSettings="searchOptions2"
            :toolbar="toolbarOptions"
            ref="adminUsersGrid"
            id="adminUsersGrid"
            :pageSettings="pageSettings"
            :showColumnChooser="true"
            :allowSorting="true"
            :allowMultiSorting="true"
            :allowFiltering="true"
          >
            <e-columns>
              <e-column
                field="username"
                headerText="Username"
                textAlign="Left"
              ></e-column>
              <e-column
                field="password"
                headerText="Password"
                textAlign="Left"
              ></e-column>
              <e-column
                field="name"
                headerText="Full Name"
                textAlign="Left"
              ></e-column>
              <e-column
                field="company"
                headerText="Company"
                textAlign="Left"
              ></e-column>
              <e-column
                field="phone"
                headerText="Phone"
                textAlign="Left"
              ></e-column>
              <e-column
                field="email"
                headerText="E-mail"
                textAlign="Left"
              ></e-column>
              <e-column
                field="roleName"
                headerText="Role"
                textAlign="Left"
              ></e-column>
              <e-column
                field="createdBy"
                headerText="Created By"
                textAlign="Left"
              ></e-column>
              <e-column
                headerText="Manage"
                textAlign="Left"
                :template="cTemplate2"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </vs-tab>
        <vs-tab label="Roles" icon="person" @click="showTab(7)">
          <vs-button size="small" @click="addRole">Add New Role</vs-button
          ><br />
          <ejs-grid
            v-if="show == 7"
            :key="'1' + refreshKey"
            :dataSource="roleData"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick6"
            :allowTextWrap="true"
            :enableStickyHeader="true"
            height="70vh"
            gridLines="Both"
            :filterSettings="filterOptions"
            :allowPaging="true"
            :searchSettings="searchOptions6"
            :toolbar="toolbarOptions"
            ref="adminRolesGrid"
            id="adminRolesGrid"
            :pageSettings="pageSettings"
            :showColumnChooser="true"
            :allowSorting="true"
            :allowMultiSorting="true"
            :allowFiltering="true"
          >
            <e-columns>
              <e-column
                field="name"
                headerText="Name"
                textAlign="Left"
              ></e-column>
              <e-column
                headerText="Manage"
                textAlign="Left"
                :template="cTemplate6"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </vs-tab>

        <vs-tab label="Commands" icon="router" @click="showTab(5)">
          <command v-if="show == 5"></command>
        </vs-tab>
      </vs-tabs>
    </vx-card>
    <div
      v-if="isLoading"
      class="w-full h-full absolute left-0 top-0 flex items-center justify-center"
      style="z-index: 999; background: #d6d6d6aa; backdrop-filter: blur(2px)"
    >
      <div class="p-4 font-bold">Please Wait</div>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate1.vue';
import columntempVue2 from './editButtonTemplate2.vue';
import columntempVue3 from './editButtonTemplate3.vue';
import columntempVue4 from './editButtonTemplate4.vue';
import columntempVue5 from './editButtonTemplate5.vue';
import columntempVue6 from './editButtonTemplate6.vue';
import vSelect from 'vue-select';
import Command from './Command.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    GridPlugin,
    columntempVue,
    columntempVue2,
    vSelect,
    Command,

    columntempVue3,
    MultiSelectPlugin,
    columntempVue4,
    columntempVue5,
    flatPickr,
    vueDropzone: vue2Dropzone,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 20.0,
        maxFiles: 1,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
      access: {
        pages: [
          { label: 'Map View', value: 'mapview' },
          { label: 'Table View', value: 'tableview' },
          { label: 'Hybrid View', value: 'hybridview' },
          { label: 'Multi View', value: 'multiview' },
          { label: 'Playback', value: 'playback' },
          { label: 'FMS (Maintenance)', value: 'fms' },
          { label: 'Vessel (VMS)', value: 'vms' },
          { label: 'Transport Mgmt (TMS)', value: 'tms' },
          { label: 'Reports', value: 'reports' },
        ],
        reports: [
          { label: 'History', value: 'History' },
          { label: 'Fuel', value: 'Fuel' },
          { label: 'Mileage', value: 'Mileage' },
          { label: 'Notification', value: 'Notification' },
          { label: 'Alarm', value: 'Alarm' },
          { label: 'Fuel Receipt', value: 'Fuel Receipt' },
          { label: 'Toll Receipt', value: 'Toll Receipt' },
          { label: 'Input', value: 'Input' },
          { label: 'Input 2', value: 'Input 2' },
          { label: 'Input 3', value: 'Input 3' },
          { label: 'Summary', value: 'Summary' },
          { label: 'Temperature', value: 'Temperature' },
          { label: 'Maintenance Log', value: 'Maintenance Log' },
          { label: 'History - Watch', value: 'History - Watch' },
          { label: 'POI - Watch', value: 'POI - Watch' },
          { label: 'POI', value: 'POI' },
          { label: 'Fatigue Driving', value: 'Fatigue Driving' },
        ],
        actions: [
          { label: 'On Immo', value: 'immo-on' },
          { label: 'Off Immo', value: 'immo-off' },
          { label: 'POI - Add', value: 'poi-add' },
          { label: 'POI - Delete', value: 'poi-delete' },
          { label: 'POI - Manage Alarms', value: 'poi-alarms' },
          { label: 'Events - Add New', value: 'events-add' },
          { label: 'Events - Update', value: 'events-update' },
          { label: 'Events - Delete Event', value: 'events-delete' },
          { label: 'Events - Admin Access', value: 'events-staff' },
          { label: 'Vessel - Agency Access', value: 'vessel-agency' },
          { label: 'Automated Reports - Add New', value: 'reports-add' },
          { label: 'Automated Reports - Update', value: 'reports-update' },
          { label: 'Automated Reports - Delete', value: 'reports-delete' },
          { label: 'Automated Reports - Admin Access', value: 'reports-staff' },
          { label: 'Smartwatch - Monitor', value: 'smartwatch-monitor' },
          { label: 'Smartwatch - Command Access', value: 'smartwatch-command' },
          { label: 'Data Push - Add New', value: 'datapush-add' },
          { label: 'Data Push - Update', value: 'datapush-update' },
          { label: 'Data Push - Delete Event', value: 'datapush-delete' },
          { label: 'Data Push - Admin Access', value: 'datapush-staff' },
        ],
      },
      show: 1,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
      iconList: [
        {
          value: 'animal-1',
          label: 'animal-1',
        },
        {
          value: 'boat-1',
          label: 'boat-1',
        },
        {
          value: 'car-1',
          label: 'car-1',
        },
        {
          value: 'machine-1',
          label: 'machine-1',
        },
        {
          value: 'truck-1',
          label: 'truck-1',
        },
        {
          value: 'truck-2',
          label: 'truck-2',
        },
        {
          value: 'truck-3',
          label: 'truck-3',
        },
        {
          value: 'item-1',
          label: 'item-1',
        },
        {
          value: 'watch-1',
          label: 'watch-1',
        },
        {
          value: 'staff-1',
          label: 'staff-1',
        },
      ],
      configdateTimePicker2: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      selectedAlarm: {
        timeRange: '',
        type: '',
        units: [],
        users: [],
        push: false,
        contacts: [],
        reference: '',
        params: [],
      },
      unitData2: [],
      refreshKey: 0,
      filteredGroup: {},
      isLoading: false,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      unitData: [],
      userData: [],
      roleData: [],
      groupData: [],
      poiData: [],
      fields1: { text: 'name', value: 'id' },
      fields2: { text: 'name', value: 'id' },
      fields3: { text: 'username', value: 'id' },
      fields4: { text: 'name', value: 'id' },
      fields5: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      fields6: { text: 'name', value: 'id' },
      daySelection: [
        {
          days: 'Monday',
          day: 'mon',
        },
        {
          days: 'Tuesday',
          day: 'tue',
        },
        {
          days: 'Wednesday',
          day: 'wed',
        },
        {
          days: 'Thursday',
          day: 'thu',
        },
        {
          days: 'Friday',
          day: 'fri',
        },
        {
          days: 'Saturday',
          day: 'sat',
        },
        {
          days: 'Sunday',
          day: 'sun',
        },
      ],
      fields12: { text: 'days', value: 'day' },
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular', 'remarks', 'fuel'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions2: {
        fields: [
          'name',
          'username',
          'password',
          'company',
          'phone',
          'email',
          'createdBy',
          'roleName',
        ],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions3: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions4: {
        fields: ['type', 'reference'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions6: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      selectedUnit: {},
      unitMetadataRefined: {
        remarks: '-',
        tempStatus: false,
        tempPreferred: 0,
        temp: -1,
        humidityStatus: false,
        humidity: -1,
        i1Status: false,
        i1: -1,
        i1_name: '',
        i2Status: false,
        i2: -1,
        i2_name: '',
        i3Status: false,
        i3: -1,
        i3_name: '',
        o1Status: false,
        o1: -1,
        o1_name: '',
        o2Status: false,
        o2: -1,
        o2_name: '',
        f1Status: false,
        fuel: -1,
        f2Status: false,
        fuel2: -1,
        totalWorkHours: 0,
        enableWorkHours: 0,
        enableWorkHoursStatus: false,
        installDate: new Date(),
        iconType: { value: 'truck-1', label: 'truck-1' },
      },
      popupActive: false,
      popupActive3: false,
      popupActive4: false,
      popupActive5: false,
      popupActive9: false,
      popupActive6: false,
      popupActive7: false,
      popupActive8: false,
      popupActive10: false,
      popupActive11: false,
      popupActive12: false,
      popupActive13: false,
      selectedUser: {},
      selectedRole: {},
      roleMetadataRefined: {
        name: '',
        createdBy: '',
        createdById: -1,
        pages: [
          'mapview',
          'tableview',
          'hybridview',
          'multiview',
          'playback',
          'tms',
          'fms',
          'reports',
        ],
        reports: [
          'History',
          'Fuel',
          'Mileage',
          'Notification',
          'Alarm',
          'Fuel Receipt',
          'Toll Receipt',
          'Input',
          'Input 2',
          'Input 3',
          'Summary',
          'Temperature',
          'Maintenance Log',
          'History - Watch',
          'POI - Watch',
          'POI',
          'Fatigue Driving'
        ],
        actions: ['immo-on', 'immo-off'],
      },
      userMetadataRefined: {},
      selectedGroup: {},
      popupActive2: false,
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate2() {
        return { template: columntempVue2 };
      },
      cTemplate3() {
        return { template: columntempVue3 };
      },
      cTemplate4() {
        return { template: columntempVue4 };
      },
      cTemplate5() {
        return { template: columntempVue5 };
      },
      cTemplate6() {
        return { template: columntempVue6 };
      },
    };
  },

  watch: {
    userMetadataRefined: {
      handler(val) {
        const self = this;

        self.userMetadataRefined.help_whatsapp = val.help_call;
      },
      deep: true,
    },
    filteredGroup(val) {
      this.filterGroup(val);
      // self.refreshKey+=1;
    },
  },
  methods: {
    filterGroup() {
      let val = this.filteredGroup;
      if (val == null || !val.id) {
        this.unitData2 = this.unitData;
        return;
      }
      if (val.unitsCount == 0) {
        this.unitData2 = [];
        return;
      }
      let tempArr = [];
      const self = this;
      if (val.unitsCount == 1) {
        tempArr = [Number(val.units)];
      } else if (val.unitsCount > 1) {
        tempArr = val.units.split(',').map(Number);
      }
      this.unitData2 = [];
      this.unitData.forEach((unit) => {
        if (tempArr.includes(unit.id)) {
          self.unitData2.push(unit);
        }
      });
    },
    bigLogoUpload(files, response) {
      const x = response.path;
      const str = x.substring(25);
      this.userMetadataRefined.logo_big_url =
        'https://api.igeotechgps.com/uploads/' + str;
    },
    smallLogoUpload(files, response) {
      const x = response.path;
      const str = x.substring(25);
      this.userMetadataRefined.logo_small_url =
        'https://api.igeotechgps.com/uploads/' + str;
    },
    smallLogoRemove() {
      this.userMetadataRefined.logo_small_url = '';
    },
    bigLogoRemove() {
      this.userMetadataRefined.logo_big_url = '';
    },
    check(val) {
      const self = this;
      if (val == 1) {
        self.unitMetadataRefined.f1Status = !self.unitMetadataRefined.f1Status;
        return (self.refreshKey += 1);
      }
      if (val == 2) {
        self.unitMetadataRefined.f2Status = !self.unitMetadataRefined.f2Status;
        return (self.refreshKey += 1);
      }
      if (val == 3) {
        self.unitMetadataRefined.i1Status = !self.unitMetadataRefined.i1Status;
        return (self.refreshKey += 1);
      }
      if (val == 4) {
        self.unitMetadataRefined.tempStatus =
          !self.unitMetadataRefined.tempStatus;
        return (self.refreshKey += 1);
      }
      if (val == 5) {
        self.unitMetadataRefined.enableWorkHoursStatus =
          !self.unitMetadataRefined.enableWorkHoursStatus;
        return (self.refreshKey += 1);
      }
      if (val == 6) {
        self.unitMetadataRefined.i2Status = !self.unitMetadataRefined.i2Status;
        return (self.refreshKey += 1);
      }
      if (val == 7) {
        self.unitMetadataRefined.o1Status = !self.unitMetadataRefined.o1Status;
        return (self.refreshKey += 1);
      }
      if (val == 8) {
        self.unitMetadataRefined.i3Status = !self.unitMetadataRefined.i3Status;
        return (self.refreshKey += 1);
      }
      if (val == 9) {
        self.unitMetadataRefined.o2Status = !self.unitMetadataRefined.o2Status;
        return (self.refreshKey += 1);
      }
      if (val == 10) {
        self.unitMetadataRefined.humidityStatus =
          !self.unitMetadataRefined.humidityStatus;
        return (self.refreshKey += 1);
      }
    },
    copyIntoWhatsapp(event) {},
    showTab(i) {
      this.show = i;
    },
    toolbarClick(args) {
      if (args.item.id === 'adminUnitsGrid_excelexport') {
        //   this.$refs.adminUnitsGrid.getColumns()[5].visible = false;
        var exportProperties = {
          fileName: 'Units - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminUnitsGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminUnitsGrid_pdfexport') {
        //        this.$refs.adminUnitsGrid.getColumns()[5].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Units - Listing.pdf',
        };
        this.$refs.adminUnitsGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick2(args) {
      if (args.item.id === 'adminGroupsGrid_excelexport') {
        //  this.$refs.adminGroupsGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Groups - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminGroupsGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminGroupsGrid_pdfexport') {
        //         this.$refs.adminGroupsGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Groups - Listing.pdf',
        };
        this.$refs.adminGroupsGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick3(args) {
      if (args.item.id === 'adminUsersGrid_excelexport') {
        //  this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Users - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminUsersGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminUsersGrid_pdfexport') {
        //               this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Users - Listing.pdf',
        };
        this.$refs.adminUsersGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick4(args) {
      if (args.item.id === 'adminPOIGrid_excelexport') {
        //   this.$refs.adminPOIGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'POI - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminPOIGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminPOIGrid_pdfexport') {
        //     this.$refs.adminPOIGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'POI - Listing.pdf',
        };
        this.$refs.adminPOIGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick5(args) {
      if (args.item.id === 'adminAlarmGrid_excelexport') {
        //   this.$refs.adminAlarmGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Alarm Sub - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminAlarmGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminAlarmGrid_pdfexport') {
        //             this.$refs.adminPOIGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Alarm Sub - Listing.pdf',
        };
        this.$refs.adminAlarmGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick6(args) {
      if (args.item.id === 'adminRolesGrid_excelexport') {
        //  this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Roles - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminRolesGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminRolesGrid_pdfexport') {
        //               this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Roles - Listing.pdf',
        };
        this.$refs.adminRolesGrid.pdfExport(exportProperties);
      }
    },
    editUnit(selectedUnit) {
      const self = this;
      self.selectedUnit = selectedUnit;
      self.$http
        .patch('admin/units/edit', {
          id: self.selectedUnit.id,
        })
        .then(function (response) {
          self.selectedUnit.groups = response.data.groups;
          self.selectedUnit.users = response.data.users;
          self.selectedUnit.oldGroups = response.data.groups;
          self.selectedUnit.oldUsers = response.data.users;
          self.selectedUnit.oldId = selectedUnit.unitId;
          self.unitMetadataRefined = JSON.parse(self.selectedUnit.meta);
          self.unitMetadataRefined.tempStatus = false;
          self.unitMetadataRefined.humidityStatus = false;
          if (
            self.unitMetadataRefined.temp == 1 ||
            self.unitMetadataRefined.temp == 2 ||
            self.unitMetadataRefined.temp == 3 ||
            self.unitMetadataRefined.temp == 4
          ) {
            self.unitMetadataRefined.tempStatus = true;
          }
          if (
            self.unitMetadataRefined.humidity == 1 ||
            self.unitMetadataRefined.humidity == 2 ||
            self.unitMetadataRefined.humidity == 3 ||
            self.unitMetadataRefined.humidity == 4
          ) {
            self.unitMetadataRefined.humidityStatus = true;
          }
          if (self.unitMetadataRefined.fuel != -1) {
            self.unitMetadataRefined.f1Status = true;
          }

          if (self.unitMetadataRefined.fuel2 != -1) {
            self.unitMetadataRefined.f2Status = true;
          }
          if (self.unitMetadataRefined.i1 != 1) {
            self.unitMetadataRefined.i1Status = false;
          }
          if (self.unitMetadataRefined.i1 == 1) {
            self.unitMetadataRefined.i1Status = true;
          }
          if (self.unitMetadataRefined.i2 != 1) {
            self.unitMetadataRefined.i2Status = false;
          }
          if (self.unitMetadataRefined.i2 == 1) {
            self.unitMetadataRefined.i2Status = true;
          }
          if (self.unitMetadataRefined.i3 != 1) {
            self.unitMetadataRefined.i3Status = false;
          }
          if (self.unitMetadataRefined.i3 == 1) {
            self.unitMetadataRefined.i3Status = true;
          }
          if (self.unitMetadataRefined.o1 != 1) {
            self.unitMetadataRefined.o1Status = false;
          }
          if (self.unitMetadataRefined.o1 == 1) {
            self.unitMetadataRefined.o1Status = true;
          }
          if (self.unitMetadataRefined.o2 != 1) {
            self.unitMetadataRefined.o2Status = false;
          }
          if (self.unitMetadataRefined.o2 == 1) {
            self.unitMetadataRefined.o2Status = true;
          }
          if (self.unitMetadataRefined.enableWorkHours != 1) {
            self.unitMetadataRefined.enableWorkHoursStatus = false;
          }
          if (self.unitMetadataRefined.enableWorkHours == 1) {
            self.unitMetadataRefined.enableWorkHoursStatus = true;
          }
          self.unitMetadataRefined.iconType = {
            value: self.unitMetadataRefined.iconType,
            label: self.unitMetadataRefined.iconType,
          };

          self.popupActive = true;
        })
        .catch(function (error) {});
    },
    editGroup(selectedGroup) {
      const self = this;
      self.selectedGroup = selectedGroup;
      self.$http
        .patch('admin/groups/edit', {
          createdById: self.userInfo.uid,
          id: self.selectedGroup.id,
        })
        .then(function (response) {
          self.selectedGroup.users = response.data.users;
          self.selectedGroup.oldUsers = response.data.users;
          if (selectedGroup.poi == '' || selectedGroup.poi == null) {
            self.selectedGroup.poi = [];
          }
          if (
            selectedGroup.poi != null &&
            selectedGroup.poi != '' &&
            !selectedGroup.poi.includes(',')
          ) {
            self.selectedGroup.poi = [Number(selectedGroup.poi)];
          }
          if (
            selectedGroup.poi != null &&
            selectedGroup.poi != '' &&
            selectedGroup.poi.includes(',')
          ) {
            self.selectedGroup.poi = selectedGroup.poi.split(',').map(Number);
          }

          if (selectedGroup.units == '' || selectedGroup.units == null) {
            self.selectedGroup.units = [];
          }

          if (
            selectedGroup.units != null &&
            selectedGroup.units != '' &&
            !selectedGroup.units.includes(',')
          ) {
            self.selectedGroup.units = [Number(selectedGroup.units)];
          }

          if (
            selectedGroup.units != null &&
            selectedGroup.units != '' &&
            selectedGroup.units.includes(',')
          ) {
            self.selectedGroup.units = selectedGroup.units
              .split(',')
              .map(Number);
          }
          self.popupActive3 = true;
          // self.refreshKey+=1;
        })
        .catch(function (error) {});
    },
    addAsset() {
      const self = this;
      self.selectedUnit = {};
      self.unitMetadataRefined = {
        remarks: '-',
        speedMetric: 'kph',
        mileageMetric: 'km',
        tempStatus: false,
        humidityStatus: false,
        tempPreferred: 0,
        temp: -1,
        humidity: -1,
        i1Status: false,
        i1: -1,
        i1_name: '',
        i2Status: false,
        i2: -1,
        i2_name: '',
        i3Status: false,
        i3: -1,
        i3_name: '',
        o1Status: false,
        o1: -1,
        o1_name: '',
        o2Status: false,
        o2: -1,
        o2_name: '',
        f1Status: false,
        fuel: -1,
        f2Status: false,
        fuel2: -1,
        totalWorkHours: 0,
        enableWorkHours: 0,
        enableWorkHoursStatus: false,
        installDate: new Date(),
        iconType: { value: 'truck-1', label: 'truck-1' },
      };
      self.popupActive2 = true;
    },
    addUser() {
      const self = this;
      self.selectedUser = {
        status: 'ACTIVE',
        role: 'Client',
      };
      self.userMetadataRefined = {
        immo: false,
        streetview: false,
        fms: false,
        status: 'ACTIVE',
        createdBy: { username: 'igeotech', name: 'Illyria Geotech' },
        logo_big_url: '',
        small_big_url: '',
      };
      self.popupActive9 = true;
    },
    addRole() {
      const self = this;
      self.roleMetadataRefined = {
        name: '',
        users: [],
        createdBy: self.userInfo.username,
        createdById: self.userInfo.uid,
        pages: [
          'mapview',
          'tableview',
          'hybridview',
          'multiview',
          'playback',
          'tms',
          'fms',
          'reports',
        ],
        reports: [
          'History',
          'Fuel',
          'Mileage',
          'Notification',
          'Alarm',
          'Fuel Receipt',
          'Toll Receipt',
          'Input',
          'Input 2',
          'Input 3',
          'Summary',
          'Temperature',
          'Maintenance Log',
          'History - Watch',
          'POI - Watch',
          'POI',
          'Fatigue Driving'
        ],
        actions: ['immo-on', 'immo-off'],
      };
      self.popupActive12 = true;
    },
    addGroup() {
      const self = this;
      self.selectedGroup = {};
      self.popupActive4 = true;
    },
    addGroup2() {
      const self = this;
      self.$http
        .post('admin/groups', {
          createdById: self.userInfo.uid,
          main: self.selectedGroup,
        })
        .then(function (response) {
          self.popupActive4 = false;
          self.getData();
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new group details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    updateGroup() {
      const self = this;
      self.$http
        .patch('admin/groups', {
          createdById: self.userInfo.uid,
          main: self.selectedGroup,
          id: self.selectedGroup.id,
        })
        .then(function (response) {
          self.popupActive3 = false;
          self.getData();
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated group details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteGroup() {
      const self = this;
      self.$http
        .delete(`admin/groups/${self.selectedGroup.id}`, {})
        .then(function (response) {
          self.getData();
          self.popupActive3 = false;
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted group records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    addUser2() {
      const self = this;

      if (
        !self.userMetadataRefined.role ||
        !self.userMetadataRefined.role.id ||
        !self.userMetadataRefined.role.name
      ) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select User Role',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      const roleId = self.userMetadataRefined.role.id || null;
      const roleName = self.userMetadataRefined.role.name || null;
      self.userMetadataRefined.roleId = roleId;
      self.userMetadataRefined.roleName = roleName;
      self.$http
        .post('admin/users', {
          main: self.selectedUser,
          meta: self.userMetadataRefined,
        })
        .then(function (response) {
          self.popupActive9 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {
            immo: 'true',
          };
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new user details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    addRole2() {
      const self = this;
      if (self.roleMetadataRefined.name == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Key in valid role name.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .post('roles', {
          meta: self.roleMetadataRefined,
        })
        .then(function (response) {
          self.popupActive12 = false;
          self.getData();
          self.roleMetadataRefined = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new role details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    addUnit() {
      const self = this;
      /*   if(self.unitMetadataRefined.tempStatus==true){
        self.unitMetadataRefined.temp=1
        }*/

      if (self.unitMetadataRefined.tempStatus == false) {
        self.unitMetadataRefined.temp = -1;
      }
      if (self.unitMetadataRefined.humidityStatus == false) {
        self.unitMetadataRefined.humidity = -1;
      }
      if (self.unitMetadataRefined.f1Status == false) {
        self.unitMetadataRefined.fuel = -1;
      }
      if (self.unitMetadataRefined.f2Status == false) {
        self.unitMetadataRefined.fuel2 = -1;
      }
      if (self.unitMetadataRefined.i1Status == true) {
        self.unitMetadataRefined.i1 = 1;
      }
      if (self.unitMetadataRefined.i1Status == false) {
        self.unitMetadataRefined.i1 = -1;
      }
      if (self.unitMetadataRefined.i2Status == true) {
        self.unitMetadataRefined.i2 = 1;
      }
      if (self.unitMetadataRefined.i2Status == false) {
        self.unitMetadataRefined.i2 = -1;
      }
      if (self.unitMetadataRefined.i3Status == true) {
        self.unitMetadataRefined.i3 = 1;
      }
      if (self.unitMetadataRefined.i3Status == false) {
        self.unitMetadataRefined.i3 = -1;
      }
      if (self.unitMetadataRefined.o1Status == true) {
        self.unitMetadataRefined.o1 = 1;
      }
      if (self.unitMetadataRefined.o1Status == false) {
        self.unitMetadataRefined.o1 = -1;
      }
      if (self.unitMetadataRefined.o2Status == true) {
        self.unitMetadataRefined.o2 = 1;
      }
      if (self.unitMetadataRefined.o1Status == false) {
        self.unitMetadataRefined.o2 = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == false) {
        self.unitMetadataRefined.enableWorkHours = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == true) {
        self.unitMetadataRefined.enableWorkHours = 1;
      }
      self.unitMetadataRefined.iconType =
        self.unitMetadataRefined.iconType.value;

      self.$http
        .post('admin/units', {
          main: self.selectedUnit,
          meta: self.unitMetadataRefined,
        })
        .then(function (response) {
          self.popupActive2 = false;
          self.getData();
          self.unitMetadataRefined = {
            remarks: '-',
            speedMetric: 'kph',
            mileageMetric: 'km',
            tempStatus: false,
            temp: -1,
            humidityStatus: false,
            humidity: -1,
            i1Status: false,
            i1: -1,
            i1_name: '',
            i2Status: false,
            i2: -1,
            i2_name: '',
            i3Status: false,
            i3: -1,
            i3_name: '',
            o1Status: false,
            o1: -1,
            o1_name: '',
            o2Status: false,
            o2: -1,
            o2_name: '',
            f1Status: false,
            fuel: -1,
            f2Status: false,
            fuel2: -1,
            installDate: new Date(),
            totalWorkHours: 0,
            enableWorkHours: 0,
            enableWorkHoursStatus: false,
          };
          self.selectedUnit = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new asset details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add asset.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    updateUnit() {
      const self = this;
      /* if(self.unitMetadataRefined.tempStatus==true){
        self.unitMetadataRefined.temp=1
        }
        if(self.unitMetadataRefined.tempStatus==false){
          self.unitMetadataRefined.temp=-1;
        } */
      if (self.unitMetadataRefined.humidityStatus == false) {
        self.unitMetadataRefined.humidity = -1;
      }
      if (self.unitMetadataRefined.f1Status == false) {
        self.unitMetadataRefined.fuel = -1;
      }
      if (self.unitMetadataRefined.f2Status == false) {
        self.unitMetadataRefined.fuel2 = -1;
      }
      if (self.unitMetadataRefined.i1Status == true) {
        self.unitMetadataRefined.i1 = 1;
      }
      if (self.unitMetadataRefined.i1Status == false) {
        self.unitMetadataRefined.i1 = -1;
      }
      if (self.unitMetadataRefined.i2Status == true) {
        self.unitMetadataRefined.i2 = 1;
      }
      if (self.unitMetadataRefined.i2Status == false) {
        self.unitMetadataRefined.i2 = -1;
      }
      if (self.unitMetadataRefined.i3Status == true) {
        self.unitMetadataRefined.i3 = 1;
      }
      if (self.unitMetadataRefined.i3Status == false) {
        self.unitMetadataRefined.i3 = -1;
      }
      if (self.unitMetadataRefined.o1Status == true) {
        self.unitMetadataRefined.o1 = 1;
      }
      if (self.unitMetadataRefined.o1Status == false) {
        self.unitMetadataRefined.o1 = -1;
      }
      if (self.unitMetadataRefined.o2Status == true) {
        self.unitMetadataRefined.o2 = 1;
      }
      if (self.unitMetadataRefined.o2Status == false) {
        self.unitMetadataRefined.o2 = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == false) {
        self.unitMetadataRefined.enableWorkHours = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == true) {
        self.unitMetadataRefined.enableWorkHours = 1;
      }
      self.unitMetadataRefined.iconType =
        self.unitMetadataRefined.iconType.value;
      self.$http
        .patch('admin/units', {
          main: self.selectedUnit,
          meta: self.unitMetadataRefined,
          id: self.selectedUnit.id,
          oldId: self.selectedUnit.oldId,
          newId: self.selectedUnit.unitId,
        })
        .then(function (response) {
          self.popupActive = false;
          self.getData();
          self.unitMetadataRefined = {};
          self.selectedUnit = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated asset details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update asset.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteUnit() {
      const self = this;
      self.$http
        .delete(
          `admin/units/${self.selectedUnit.id}/${self.selectedUnit.unitId}`,
          {},
        )
        .then(function (response) {
          self.popupActive = false;
          self.getData();
          self.unitMetadataRefined = {};
          self.selectedUnit = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted asset records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete asset.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteUserSessions() {
      const self = this;
      self.$http
        .patch(`admin/users-clear-sessions/${self.selectedUser.id}`, {})
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted user sessions records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user sessions.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user sessions.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete user sessions.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    removeContact(index) {
      this.selectedAlarm.contacts.splice(index, 1);
    },
    removeTelegram(index) {
      this.userMetadataRefined.telegram.splice(index, 1);
    },
    addContact() {
      this.selectedAlarm.contacts.push({ type: '', detail: '', remark: '' });
    },
    deleteUser() {
      const self = this;
      self.$http
        .delete(`admin/users/${self.selectedUser.id}`, {})
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted user records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteRole() {
      const self = this;
      self.$http
        .delete(`roles/${self.selectedRole.id}`, {})
        .then(function (response) {
          self.popupActive13 = false;
          self.getData();
          self.roleMetadataRefined = {};
          self.selectedRole = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    editUser(selectedUser) {
      const self = this;
      self.selectedUser = selectedUser;
      if (selectedUser.groups == '' || selectedUser.groups == null) {
        self.selectedUser.groups = [];
      }
      if (
        selectedUser.groups != null &&
        selectedUser.groups != '' &&
        !selectedUser.groups.includes(',')
      ) {
        self.selectedUser.groups = [Number(selectedUser.groups)];
      }
      if (
        selectedUser.groups != null &&
        selectedUser.groups != '' &&
        selectedUser.groups.includes(',')
      ) {
        self.selectedUser.groups = selectedUser.groups.split(',').map(Number);
      }
      if (selectedUser.units == '' || selectedUser.units == null) {
        self.selectedUser.units = [];
      }
      if (
        selectedUser.units != null &&
        selectedUser.units != '' &&
        !selectedUser.units.includes(',')
      ) {
        self.selectedUser.units = [Number(selectedUser.units)];
      }
      if (
        selectedUser.units != null &&
        selectedUser.units != '' &&
        selectedUser.units.includes(',')
      ) {
        self.selectedUser.units = selectedUser.units.split(',').map(Number);
      }
      self.userMetadataRefined = JSON.parse(self.selectedUser.meta);
      self.userMetadataRefined.telegram = JSON.parse(
        self.userMetadataRefined.telegram,
      );
      self.userMetadataRefined.role = [Number(self.userMetadataRefined.roleId)];
      self.popupActive5 = true;
    },
    editRole(data) {
      const self = this;
      self.selectedRole = data;
      self.roleMetadataRefined = JSON.parse(data.meta);
      self.roleMetadataRefined.users = data.users;
      self.popupActive13 = true;
    },
    updateRole() {
      const self = this;
      if (self.roleMetadataRefined.name == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Key in valid role name.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .patch('roles', {
          id: self.selectedRole.id,
          meta: self.roleMetadataRefined,
        })
        .then(function (response) {
          self.popupActive13 = false;
          self.getData();
          self.roleMetadataRefined = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    updateUser() {
      const self = this;
      if (!self.userMetadataRefined.createdBy) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select created by user.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      if (!self.userMetadataRefined.role || !self.userMetadataRefined.role[0]) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select User Role',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      const ind = self.roleData.findIndex(
        (x) => x.id == self.userMetadataRefined.role[0],
      );
      self.userMetadataRefined.roleId = self.roleData[ind].id;
      self.userMetadataRefined.roleName = self.roleData[ind].name;
      self.userMetadataRefined.role = null;
      self.$http
        .patch('admin/users', {
          main: self.selectedUser,
          meta: self.userMetadataRefined,
          id: self.selectedUser.id,
        })
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated user details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: `Could not update user.${response.data.error}`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    getData() {
      const self = this;
      self.isLoading = true;
      self.$http
        .get('admin/main', {})
        .then(async function (response) {
          if (response.status == 200 && response.data.success) {
            let obj = [
              ['unitData2', 'unitData'],
              ['unitData', 'unitData'],
              ['userData', 'userData'],
              ['groupData', 'groupData'],
              ['poiData', 'poiData'],
              ['roleData', 'roleData'],
            ];
            for (let index = 0; index < obj.length; index++) {
              let element = obj[index];
              // console.log(index);
              await self.batchUpdate(self, response, element, index * 10);
              continue;
            }
            self.filterGroup();
            self.isLoading = false;
          } else if (response.data.error) {
            self.isLoading = false;
          } else {
            self.isLoading = false;
          }
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    async batchUpdate(self, response, element, timeout) {
      return new Promise((resolve) => {
        setTimeout(() => {
          self[element[0]] = response.data[element[1]];
          resolve();
        }, timeout);
      });
    },
    startDrawing() {
      this.selectedPOI.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.POLYGON,
      );
    },
    stopDrawing() {
      this.selectedPOI.drawingManager.setDrawingMode(null);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.row-iconBox {
  display: flex;
  justify-content: space-between;
}

.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
